import {
  FaEnvelope,
  FaPhoneAlt,
  FaUserCircle,
  FaBriefcase,
  FaUserTie,
  FaPaperPlane,
  FaGlobe,
  FaWhatsapp,
} from "react-icons/fa";
import ContactCard from "../../Components/Card/Contact-Card";
import { useInfoProvider } from "../../context/InfoContext";
import { useRef, useState } from "react";
import emailjs from "@emailjs/browser";

const Contact = () => {
  const { info } = useInfoProvider();
  const formRef = useRef();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const encodedAddress = encodeURIComponent(
    info?.address || "Malad East, Mumbai, Maharashtra"
  );
  const mapUrl = `https://maps.google.com/maps?q=${encodedAddress}&output=embed`;
  const sendEmail = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    emailjs
      .sendForm("service_k7ya4u9", "template_4dbaz89", formRef.current, {
        publicKey: "DHRH_13zbIK-QFhhO",
      })
      .then(
        (result) => {
          console.log(result.text);
          setSubmitStatus("success");
          formRef.current.reset();
        },
        (error) => {
          console.log(error.text);
          setSubmitStatus("error");
        }
      )
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  return (
    <div className="w-full pt-10 bg-[#f4f9ff]">
      {/* Hero Section */}
      <div className="bg-blue-600 text-white py-16">
        <div className="container mx-auto px-6 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            Let's Get Started!
          </h1>
          <div className="flex flex-col md:flex-row justify-center gap-8 mb-10">
            <div className="bg-white text-blue-600 p-6 rounded-xl shadow-lg max-w-md">
              <div className="flex items-center justify-center mb-4">
                <FaBriefcase className="text-3xl mr-3" />
                <h3 className="text-xl font-bold">Employers</h3>
              </div>
              <p className="text-gray-700">
                Post a job and get the right talent fast.
              </p>
            </div>
            <div className="bg-white text-blue-600 p-6 rounded-xl shadow-lg max-w-md">
              <div className="flex items-center justify-center mb-4">
                <FaUserTie className="text-3xl mr-3" />
                <h3 className="text-xl font-bold">Job Seekers</h3>
              </div>
              <p className="text-gray-700">
                Enroll now and start earning immediately.
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* Contact Info Section */}
      <div className="container mx-auto p-6 py-16">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-gray-800">
            Ready to Work? Ready to Hire?
          </h2>
          <p className="text-xl text-blue-600 font-semibold mb-8">
            Contact GIGSAM Today!
          </p>
          {/* <div className="bg-white inline-block px-6 py-6 rounded-full shadow-md">
            <a
              // href="https://forms.gle/..."
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center text-blue-600 font-semibold"
            >
              <FaPaperPlane className="mr-2" />
              Google Enquiry Form
            </a>
          </div> */}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
          <ContactCard
            icon={<FaEnvelope className="text-2xl" />}
            title="Email Us"
            details={[info?.app_email]}
          />
          <ContactCard
            icon={<FaWhatsapp className="text-2xl" />}
            title="Call Us"
            details={[info?.app_contact]}
          />
          <ContactCard
            icon={<FaGlobe className="text-2xl" />}
            title="Visit Us"
            details={[info?.app_website]}
          />
        </div>

        <div className="text-center">
          <h3 className="text-2xl font-bold text-gray-800 mb-2">
            GIGSAM – Fast. Reliable. Workforce Solutions.
          </h3>
        </div>
      </div>
      {/* Contact Form Section */}
      <div className="container mx-auto p-6 flex flex-col md:flex-row gap-8 mb-16">
        <div className="bg-white shadow-xl rounded-2xl p-8 flex-1">
          <h2 className="text-3xl font-bold mb-6 text-gray-800">
            Send Us a Message
          </h2>

          {/* Status Messages */}
          {submitStatus === "success" && (
            <div className="mb-6 p-4 bg-green-100 text-green-700 rounded-lg flex items-center">
              <svg
                className="h-5 w-5 mr-2"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M5 13l4 4L19 7"
                />
              </svg>
              Thank you! Your message has been sent successfully.
            </div>
          )}

          {submitStatus === "error" && (
            <div className="mb-6 p-4 bg-red-100 text-red-700 rounded-lg flex items-center">
              <svg
                className="h-5 w-5 mr-2"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              Oops! Something went wrong. Please try again.
            </div>
          )}

          <form ref={formRef} onSubmit={sendEmail} className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-gray-700 mb-2">Name*</label>
                <input
                  type="text"
                  name="user_name"
                  className="w-full p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  required
                />
              </div>
              <div>
                <label className="block text-gray-700 mb-2">Phone</label>
                <input
                  type="text"
                  name="user_phone"
                  className="w-full p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-gray-700 mb-2">Email*</label>
                <input
                  type="email"
                  name="user_email"
                  className="w-full p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  required
                />
              </div>
              <div>
                <label className="block text-gray-700 mb-2">Subject*</label>
                <input
                  type="text"
                  name="subject"
                  className="w-full p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  required
                />
              </div>
            </div>

            <div>
              <label className="block text-gray-700 mb-2">Message*</label>
              <textarea
                name="message"
                className="w-full p-4 border border-gray-300 rounded-lg h-40 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
                required
              ></textarea>
            </div>

            <button
              type="submit"
              disabled={isSubmitting}
              className={`bg-blue-600 hover:bg-blue-700 text-white font-bold py-4 px-8 rounded-lg transition duration-300 shadow-lg ${
                isSubmitting ? "opacity-70 cursor-not-allowed" : ""
              }`}
            >
              {isSubmitting ? (
                <>
                  <svg
                    className="animate-spin -ml-1 mr-3 h-5 w-5 text-white inline"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                  Sending...
                </>
              ) : (
                "Send Message"
              )}
            </button>
          </form>
        </div>
        <div className="w-full md:w-1/3">
          <div className="bg-blue-600 text-white rounded-t-2xl p-8 text-center h-full">
            <div className="flex flex-col items-center justify-center h-full">
              <FaUserCircle className="text-5xl mb-4" />
              <h3 className="text-2xl font-bold mb-2">Support Hours</h3>
              <p className="text-xl mb-1">Monday - Friday</p>
              <p className="text-xl font-semibold mb-4">10:00 AM to 06:00 PM</p>
              <p className="text-lg">Saturday, Sunday - Closed</p>
            </div>
          </div>
        </div>
      </div>
      {/* Map Section */}
      <div className="container mx-auto px-6 mb-16">
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
          <iframe
            src={mapUrl}
            className="w-full h-[500px] border-0"
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title={`${info?.address || "Our"} Location`}
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default Contact;
